import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { andOr } from 'src/app/interfaces/andOr';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { operator } from 'src/app/interfaces/operator';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { partipo } from 'src/app/interfaces/partipo';
import { validateBasis } from '@angular/flex-layout';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { Filter } from 'src/app/interfaces/filter';

@Component({
    selector: 'filterview',
    templateUrl: './filterview.component.html',
    styleUrls: ['./filterview.component.css'],
    standalone: false
})
export class FilterviewComponent implements OnInit,AfterViewInit,OnChanges {

  disableVariable = false;
  visible = true;
  selectable = true;
  removable = true;
  filterForm: UntypedFormGroup;
  filteredFields: Observable<columnsDef[]>;
  public fields: string[] = [];
  selectedField: columnsDef;
  operatorSelected:boolean = false;
  fieldSelected:boolean = false;
  andOrSelected:boolean = false;
  disableValue:boolean  =true;
  typeField:string = "text"
  @Input()allFields:columnsDef[];
  @Input()editing:Filter;
  btnDisable:boolean = true;
  value:string = "";
  valueOperator = "";
  valueField = "";
  valueValue = "";
  valueAndOr = "";
  valueTipo = "";
  selectedLinha:columnsDef;
  checked = false;
  showTextBox = false;
  variable = new UntypedFormControl(false);
  public customPatterns = { '0': { pattern: new RegExp('\[A-Z\]')} };
  //@Output() filter:EventEmitter<string[]> = new EventEmitter();
  

  operators:operator[] = [{name:"igual",value:"="},
             {name:"diferente",value:"!="}, 
             {name:"contem",value:"like"}, 
             {name:"não contem",value:"not like"}, 
             {name:"maior",value:">"},
             {name:"maior igual",value:">="},
             {name:"menor",value:"<"},
             {name:"menor igual",value:"<="},
             {name:"contendo",value:"in"},
             {name:"não contendo",value:"not in"},
             {name:"não nulo",value:"is not null"},
             {name:"é nulo",value:"is null"}
            ]

  partipo:partipo[] = [{name:"Texto",value:"S"},
            {name:"Inteiro",value:"I"}, 
            {name:"Numérico",value:"N"}, 
            {name:"Data",value:"D"},
            {name:"Lista", value:"L"}
    ]

   andOrList:andOr[]= [
     {name:"E", value:"AND"},
     {name:"OU", value:"OR"}
    ]

  @ViewChild('fieldInput') fieldInput: ElementRef<HTMLInputElement>;

  constructor(private _formBuilder: UntypedFormBuilder, private snackServices: SnackbarService) {

    this.filterForm = this._formBuilder.group({
      fieldsCtrl: '',
      operatorCtrl:'',
      valueCtrl:'',
      andOrCtrl:'',
      expressaoCtrl:'',
      valueNomeParCtrl: ['', Validators.pattern('^[a-zA-Z ]*$')],
      valueDescParCtrl:'',
      valueTipoParCtrl:'',
      valueListOpCtrl:''

    });
    
    this.filterForm.get('valueCtrl').disable();
    this.filterForm.get('andOrCtrl').disable();

    
  }
  
  ngOnInit(): void {
    
    this.filteredFields = this.filterForm.get("fieldsCtrl").valueChanges.pipe(
      startWith(''),
      map((fields: string | null) => fields ? this._filter(fields) : this.allFields)
    );

    // if ( this.filterForm.get('fieldsCtrl')!=null ){
    //   this.filteredFields = this.filterForm.get('fieldsCtrl').valueChanges.subscribe(data=>{
    //     pipe(return map(d=>this._filter(data)));
    //   });
      

      // 
    //}
      
  } 

  onDoubleClick(){
    //if ( this.editing ){
        let data = "";
        this.fields.forEach(f=>{
            data = data + f;
        })

        this.fields = [];

        this.filterForm.get('expressaoCtrl').setValue(data);
        this.value = data;
    //}
  }

  drop(event: CdkDragDrop<String[]>) {
    moveItemInArray(this.fields, event.previousIndex, event.currentIndex);
  }

  chipColorFn(value:string):string{
 
    if ( value.trim().toUpperCase() == "AND"  ){
      return "#A0E7E5";
    }

    
    if ( value.trim().toUpperCase() == "OR"  ){
      return "#B4F8C8"
    }

    return "#FBE7C6"


  }

  addExpression(input: HTMLInputElement):void{
    const value = (input.value || '').trim();
    if ( value == ""){
      return;
    }

    this.fields.push(value);
    input.value = '';

    this.filterForm.get('expressaoCtrl').setValue(null);
  }

  add(): void {
    
    if ( this.filterForm.invalid ){
      this.snackServices.showError("Existem erros no filtro.");
      return;
    }

    this.fields.push("this."+this.value); //jdbc
    //this.fields.push(this.value);
    
    if ( this.valueAndOr != null && this.valueAndOr !="" && this.valueAndOr != undefined){
      
      this.fields.push(this.valueAndOr);
    }
    
    this.value = '';
    
    this.filterForm.get("fieldsCtrl").patchValue('');
    this.filterForm.get("operatorCtrl").patchValue('');
    this.filterForm.get("valueCtrl").patchValue('');
    this.filterForm.get("andOrCtrl").patchValue('');

    this.filterForm.get("valueNomeParCtrl").patchValue('');
    this.filterForm.get("valueDescParCtrl").patchValue('');
    this.filterForm.get("valueTipoParCtrl").patchValue('');
    this.filterForm.get("valueListOpCtrl").patchValue('');

    this.valueOperator = "";
    this.valueField = "";
    this.valueValue = "";
    this.valueAndOr = "";
    this.valueTipo = "";
    this.btnDisable = true;
    this.checked = false;
    this.variable.setValue(false);
  }

  remove(field: string): void {
    const index = this.fields.indexOf(field);

    if (index >= 0) {
      this.fields.splice(index, 1);
    }
  }

  ngAfterViewInit(): void { 
    
    this.filterForm.get("fieldsCtrl").setValue(''); 
    
    this.allFields.sort((a:columnsDef,b:columnsDef)=>{
      if (a.COLUMNDESC > b.COLUMNDESC  ) return 1;
      if (a.COLUMNDESC < b.COLUMNDESC  ) return -1;
      return 0;
    });
  }

  ngOnChanges(changes: SimpleChanges){
    
    if ( this.editing ){
      this.fields.push(this.editing.expression);
    }
    
    if ( changes.allFields != null  ){
      
      if ( changes.allFields.firstChange && changes.allFields.currentValue != null && changes.allFields.currentValue.length > 0){
        this.allFields.sort((a:columnsDef,b:columnsDef)=>{
          if (a.COLUMNDESC > b.COLUMNDESC  ) return 1;
          if (a.COLUMNDESC < b.COLUMNDESC  ) return -1;
          return 0;
        });
        this.filteredFields = new Observable<columnsDef[]>(data=>data.next( this.allFields));  
      }
    }
           

  }

  clearAll(){
    this.filterForm.get('expressaoCtrl').setValue(null);
    this.value = "";
    this.fields = [];
    this.editing  = null;
  }

  validateFields(){
    
    if ( this.selectedLinha == null){
      this.snackServices.showError("Não selecionado o campo de filtro.");
      return;
    }


    if ( (this.filterForm.get('valueNomeParCtrl').value != "" && 
    this.filterForm.get('valueDescParCtrl').value != "" && 
    this.valueTipo != "") || ( (this.filterForm.get('valueNomeParCtrl').value != "" && 
    this.filterForm.get('valueDescParCtrl').value != "" && 
    this.valueTipo != "") && this.valueTipo == "L" && this.filterForm.get('valueListOpCtrl').value != "" )
      ){


      this.btnDisable = false;
     
      this.settingValue(true);
     
    }
  }
  transformToArray(value: string):{view:string,value:string}[] {
    
      var list:{view:string,value:string}[] = [];

      value.split('\n').forEach(s=>{
          var value =  s.split('=')[0];
          var view =  s.split('=')[1];
          list.push({value:value,view:view})
      })  
     return list;
  }

  inputValue(event:Event){
    
    if ( this.checked ){
        this.validateFields();
    
    }else{
      this.btnDisable=false
      this.valueValue = (event.target as HTMLInputElement).value;
  
      this.settingValue(false);
      
    }
    
    
    event.preventDefault();
    event.stopImmediatePropagation();

  }

  onCheckClick(){
      this.checked = this.variable.value;

      if ( this.checked ){

      }
  }

  selectParTipo(value: string){

    this.valueTipo = value;

    if ( this.valueTipo == 'L'){
        this.showTextBox = true;
    }else{
      this.showTextBox = false;
    }
    this.validateFields();

    
  }

  selectAndOr(value: string){
    this.andOrSelected = true;
    this.disableValue = !(this.fieldSelected && this.operatorSelected );
    this.valueAndOr = value;
    
    if ( this.disableValue ){
      this.filterForm.get('valueCtrl').disable();
      this.filterForm.get('andOrCtrl').disable();
      this.filterForm.get('valueNomeParCtrl').disable();
      this.filterForm.get('valueDescParCtrl').disable();
      this.filterForm.get('valueTipoParCtrl').disable();
      
    }else{
      this.filterForm.get('valueCtrl').enable();
      this.filterForm.get('andOrCtrl').enable();
      this.filterForm.get('valueNomeParCtrl').enable();
      this.filterForm.get('valueDescParCtrl').enable();
      this.filterForm.get('valueTipoParCtrl').enable();
    }
     
    if ( this.checked ){
      this.settingValue(true);
    }else{
      this.settingValue(false);
    }
    
    
  }


  settingValue(variable:boolean){
    
    if ( !variable ){
      
      if ( this.selectedLinha != null && (this.selectedLinha.DATATYPE == "VARCHAR" ||this.selectedLinha.DATATYPE == "DATETIME" )){
        if ( this.valueOperator == "like" || this.valueOperator =="not like"){
          this.value = this.valueField+" " + this.valueOperator +" '%" + this.valueValue+"%'";
        }else{
          this.value = this.valueField+" " + this.valueOperator +" '" + this.valueValue+"'";
        }
        
      }else{
        this.value = this.valueField+" " + this.valueOperator +" " + this.valueValue;
      }
    
    }else{
      
      if ( this.selectedLinha != null && (this.selectedLinha.DATATYPE == "VARCHAR" ||this.selectedLinha.DATATYPE == "DATETIME") ){

        if ( this.valueOperator == "like" || this.valueOperator =="not like"){
          this.value = this.valueField+" " + this.valueOperator +" '%"+JSON.stringify({
            nome: this.filterForm.get('valueNomeParCtrl').value,
            desc: this.filterForm.get('valueDescParCtrl').value,
            tipo: this.valueTipo,
            lista: this.transformToArray(this.filterForm.get('valueListOpCtrl').value)
        })+"%'"
        }else{
          this.value = this.valueField+" " + this.valueOperator +" '"+JSON.stringify({
            nome: this.filterForm.get('valueNomeParCtrl').value,
            desc: this.filterForm.get('valueDescParCtrl').value,
            tipo: this.valueTipo,
            lista: this.transformToArray(this.filterForm.get('valueListOpCtrl').value)
        })+"'"
        }
        
      }else{
        this.value = this.valueField+" " + this.valueOperator + " " +JSON.stringify({
          nome: this.filterForm.get('valueNomeParCtrl').value,
          desc: this.filterForm.get('valueDescParCtrl').value,
          tipo: this.valueTipo,
          lista: this.transformToArray(this.filterForm.get('valueListOpCtrl').value)
      })
      }
    }
    
  }


  selectedOperation(value: string){
    this.operatorSelected = true;
    this.disableValue = !(this.fieldSelected && this.operatorSelected );
    this.valueOperator = value;

    if ( this.valueOperator =="in" || this.valueOperator =="not in"){
      this.typeField= "text";
    }

    if ( this.valueOperator == "is null" || this.valueOperator == "is not null"){
        this.filterForm.get('valueCtrl').disable();
        this.filterForm.get('valueNomeParCtrl').disable();
        this.filterForm.get('valueDescParCtrl').disable();
        this.filterForm.get('valueTipoParCtrl').disable();
        this.disableVariable = true;
        this.btnDisable = false;
        return;
    }

    if ( this.disableValue ){
      this.filterForm.get('valueCtrl').disable();
      this.filterForm.get('andOrCtrl').disable();
      this.filterForm.get('valueNomeParCtrl').disable();
      this.filterForm.get('valueDescParCtrl').disable();
      this.filterForm.get('valueTipoParCtrl').disable();
    }else{
      this.filterForm.get('valueCtrl').enable();
      this.filterForm.get('andOrCtrl').enable();
      this.filterForm.get('valueNomeParCtrl').enable();
      this.filterForm.get('valueDescParCtrl').enable();
      this.filterForm.get('valueTipoParCtrl').enable();
    }
      
    this.settingValue(false);
  }

  selected(field: string): void {
      this.selectedLinha =  this.allFields.find(c=>c.COLUMNNAME === field.toUpperCase());
      
      if ( this.selectedLinha.DATATYPE == "FLOAT" || this.selectedLinha.DATATYPE == "INT"){
        this.typeField= "number";
      }

      
      if ( this.selectedLinha.DATATYPE == "DATETIME" || this.selectedLinha.DATATYPE == "DATE"  ){
        this.typeField= "date";
      }

      if ( this.selectedLinha.DATATYPE == "VARCHAR"){
        this.typeField= "text";
      }

      this.selectedField = this.selectedLinha;
      this.fieldSelected = true;
      this.valueField = field;
      this.disableValue = !(this.fieldSelected && this.operatorSelected);
      
      if ( this.disableValue ){
        this.filterForm.get('valueCtrl').disable();
        this.filterForm.get('andOrCtrl').disable();
        this.filterForm.get('valueNomeParCtrl').disable();
        this.filterForm.get('valueDescParCtrl').disable();
        this.filterForm.get('valueTipoParCtrl').disable();
      }else{
        this.filterForm.get('valueCtrl').enable();
        this.filterForm.get('andOrCtrl').enable();
        this.filterForm.get('valueNomeParCtrl').enable();
        this.filterForm.get('valueDescParCtrl').enable();
        this.filterForm.get('valueTipoParCtrl').enable();
      }

      this.settingValue(false);

  }

  _filter(value: string): columnsDef[] {
    const filterValue = value.toLowerCase();
    return this.allFields.filter(field => field.COLUMNNAME.toLowerCase().indexOf(filterValue.toLowerCase()) === 0);
  }
}
